// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1pTU-mNdaGB6AvO_G2fu9N","signup":"fFDTi6C6Hxg7mDwrKFW8k","rotating":"_2tVDzdhvRjyDL_sgyZkIPB"};